<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle" :bordered="false">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <store-tenant-select domain="sale" @change="handleStoreTenantChange"></store-tenant-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker
                      style="width: 100%"
                      v-model="queryParam.dateRange"
                      format="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      @change="onDateChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" icon="printer" v-if="btnEnableList.indexOf('5')>-1"
                      @click="handlePrint">打印</a-button>
                    <a-button style="margin-left: 8px" @click="exportExcel" icon="download" v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <section id="reportPrint">
            <!-- 利润汇总头部 -->
            <div class="box-body form-inline detail-head">
              <div class="detail-head-group">利润</div>
              <div class="detail-head-group">=</div>
              <div class="detail-head-group">收入</div>
              <div class="detail-head-group">-</div>
              <div class="detail-head-group">支出</div>
            </div>
            <div class="box-body form-inline detail-head">
              <div class="detail-head-group"><span id="profit" class="text-red">￥{{ profitText }}</span></div>
              <div class="detail-head-group">&nbsp;</div>
              <div class="detail-head-group"><span id="incomeTotal">{{ incomeText }}</span></div>
              <div class="detail-head-group">&nbsp;</div>
              <div class="detail-head-group"><span id="paymentTotal">{{ paymentText }}</span></div>
            </div>
            <!-- 利润汇总明细 -->
            <div class="box-body form-inline detail-item">
              <ul>
                <li>
                  <div class="group-head-left"><b>项目列表</b></div>
                  <div class="group-head-right"><b>本期金额（元）</b></div>
                </li>
                <li>
                  <div class="group-item-left">【收入类】</div>
                  <div class="group-item-right"><span class="text-red">{{ incomeTotal }}</span></div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">零售出库</div>
                  <div class="group-item-right">{{ retailOut }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">销售订单</div>
                  <div class="group-item-right">{{ saleOrder }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">销售出库</div>
                  <div class="group-item-right">{{ saleOut }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">采购退货</div>
                  <div class="group-item-right">{{ purchaseBack }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">盘盈</div>
                  <div class="group-item-right">{{ stockCheckProfit }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">收入单</div>
                  <div class="group-item-right">{{ itemIn }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">收款单</div>
                  <div class="group-item-right">{{ moneyIn }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">收预付款</div>
                  <div class="group-item-right">{{ advanceIn }}</div>
                </li>
                <li>
                  <div class="group-item-left">【支出类】</div>
                  <div class="group-item-right"><span class="text-red">{{ paymentTotal }}</span></div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">零售退货</div>
                  <div class="group-item-right">{{ retailBack }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">销售退货</div>
                  <div class="group-item-right">{{ saleBack }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">采购订单</div>
                  <div class="group-item-right">{{ purchaseOrder }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">采购入库</div>
                  <div class="group-item-right">{{ purchaseIn }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">盘亏</div>
                  <div class="group-item-right">{{ stockCheckLoss }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">支出单</div>
                  <div class="group-item-right">{{ itemOut }}</div>
                </li>
                <li class="item-padd">
                  <div class="group-item-left">付款单</div>
                  <div class="group-item-right">{{ moneyOut }}</div>
                </li>
                <li>
                  <div class="group-item-left">利润</div>
                  <div class="group-item-right"><span class="text-red">{{ profitText }}</span></div>
                </li>
              </ul>
            </div>
            <div class="form-tip">注：销售订单只统计订金，销售出库只统计收款，订金+收款=订单应收金额；采购订单只统计订金，采购入库只统计付款，订金+付款=订单应付金额</div>
          </section>
        </a-card>
      </a-col>
    </a-row>
    </template>

    <!-- 打印模式（内嵌） -->
    <template v-if="printMode">
      <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="printItems"
        :queryParam="printQueryParam"
        billType="PROFIT_REPORT"
        billTypeName="利润报表"
        :buildData="buildPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
      />
    </template>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getDetail } from '@/api/plugin/profitReport'
import moment from 'moment'
import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
import StoreTenantSelect from '@/components/StoreTenantSelect'
import { buildPrintData } from './profitReportConfig'

export default {
  name: 'ProfitReport',
  mixins: [JeecgListMixin],
  components: { ReportPrint, StoreTenantSelect },
  data() {
    return {
      urlPath: '/plugins/profit_report',
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      printMode: false,
      printTitle: '利润报表-打印预览',
      printItems: [],
      printQueryParam: {},
      queryParam: {
        dateRange: [moment().subtract(3, 'months'), moment()],
        beginTime: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      },
      // Data fields
      profit: 0,
      incomeTotal: 0,
      paymentTotal: 0,
      retailOut: 0,
      saleOrder: 0,
      saleOut: 0,
      purchaseBack: 0,
      stockCheckProfit: 0,
      itemIn: 0,
      moneyIn: 0,
      advanceIn: 0,
      retailBack: 0,
      saleBack: 0,
      purchaseOrder: 0,
      purchaseIn: 0,
      stockCheckLoss: 0,
      itemOut: 0,
      moneyOut: 0
    }
  },
  computed: {
    profitText() { return '￥' + this.profit.toFixed(2) },
    incomeText() { return '￥' + this.incomeTotal.toFixed(2) },
    paymentText() { return '￥' + this.paymentTotal.toFixed(2) }
  },
  methods: {
    buildPrintData,
    handleStoreTenantChange() {
      this.searchQuery()
    },
    onDateChange(dates, dateStrings) {
      if (dateStrings[0] && dateStrings[1]) {
        this.queryParam.beginTime = dateStrings[0]
        this.queryParam.endTime = dateStrings[1]
      }
    },
    loadData() {
      this.loading = true
      getDetail({ beginTime: this.queryParam.beginTime, endTime: this.queryParam.endTime })
        .then(res => {
          if (res && res.code === 200) {
            const data = res.data
            this.profit = data.profit || 0
            const income = data.income || {}
            const payment = data.payment || {}
            this.incomeTotal = income.total || 0
            this.paymentTotal = payment.total || 0
            this.retailOut = income.retailOut || 0
            this.saleOrder = income.saleOrder || 0
            this.saleOut = income.saleOut || 0
            this.purchaseBack = income.purchaseBack || 0
            this.stockCheckProfit = income.stockCheckProfit || 0
            this.itemIn = income.itemIn || 0
            this.moneyIn = income.moneyIn || 0
            this.advanceIn = income.advanceIn || 0
            this.retailBack = payment.retailBack || 0
            this.saleBack = payment.saleBack || 0
            this.purchaseOrder = payment.purchaseOrder || 0
            this.purchaseIn = payment.purchaseIn || 0
            this.stockCheckLoss = payment.stockCheckLoss || 0
            this.itemOut = payment.itemOut || 0
            this.moneyOut = payment.moneyOut || 0
          }
        })
        .catch(err => {
          console.error('利润报表查询失败', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getQueryParams() {
      return {
        beginTime: this.queryParam.beginTime,
        endTime: this.queryParam.endTime
      }
    },
    searchQuery() {
      this.loadData()
    },
    // Export Excel
    exportExcel() {
      const rows = [
        { item: '利润', amount: '￥' + this.profit.toFixed(2) },
        { item: '收入', amount: '￥' + this.incomeTotal.toFixed(2) },
        { item: '支出', amount: '￥' + this.paymentTotal.toFixed(2) },
        { item: '【收入类】', amount: this.incomeTotal.toFixed(2) },
        { item: '  零售出库', amount: this.retailOut.toFixed(2) },
        { item: '  销售订单', amount: this.saleOrder.toFixed(2) },
        { item: '  销售出库', amount: this.saleOut.toFixed(2) },
        { item: '  采购退货', amount: this.purchaseBack.toFixed(2) },
        { item: '  盘盈', amount: this.stockCheckProfit.toFixed(2) },
        { item: '  收入单', amount: this.itemIn.toFixed(2) },
        { item: '  收款单', amount: this.moneyIn.toFixed(2) },
        { item: '  收预付款', amount: this.advanceIn.toFixed(2) },
        { item: '【支出类】', amount: this.paymentTotal.toFixed(2) },
        { item: '  零售退货', amount: this.retailBack.toFixed(2) },
        { item: '  销售退货', amount: this.saleBack.toFixed(2) },
        { item: '  采购订单', amount: this.purchaseOrder.toFixed(2) },
        { item: '  采购入库', amount: this.purchaseIn.toFixed(2) },
        { item: '  盘亏', amount: this.stockCheckLoss.toFixed(2) },
        { item: '  支出单', amount: this.itemOut.toFixed(2) },
        { item: '  付款单', amount: this.moneyOut.toFixed(2) },
        { item: '利润', amount: this.profit.toFixed(2) }
      ]
      const head = ['项目列表', '本期金额（元）']
      const list = rows.map(row => [row.item, row.amount])
      const tip = '日期:' + this.queryParam.beginTime + '~' + this.queryParam.endTime
      this.handleExportXlsPost('利润报表', '利润报表', head, tip, list)
    },
    handlePrint() {
      this.printTitle = '利润报表-打印预览'
      this.printItems = [
        { rowIndex: 1, item: '利润', amount: '￥' + this.profit.toFixed(2) },
        { rowIndex: 2, item: '收入', amount: '￥' + this.incomeTotal.toFixed(2) },
        { rowIndex: 3, item: '支出', amount: '￥' + this.paymentTotal.toFixed(2) },
        { rowIndex: 4, item: '【收入类】', amount: this.incomeTotal.toFixed(2) },
        { rowIndex: 5, item: '零售出库', amount: this.retailOut.toFixed(2) },
        { rowIndex: 6, item: '销售订单', amount: this.saleOrder.toFixed(2) },
        { rowIndex: 7, item: '销售出库', amount: this.saleOut.toFixed(2) },
        { rowIndex: 8, item: '采购退货', amount: this.purchaseBack.toFixed(2) },
        { rowIndex: 9, item: '盘盈', amount: this.stockCheckProfit.toFixed(2) },
        { rowIndex: 10, item: '收入单', amount: this.itemIn.toFixed(2) },
        { rowIndex: 11, item: '收款单', amount: this.moneyIn.toFixed(2) },
        { rowIndex: 12, item: '收预付款', amount: this.advanceIn.toFixed(2) },
        { rowIndex: 13, item: '【支出类】', amount: this.paymentTotal.toFixed(2) },
        { rowIndex: 14, item: '零售退货', amount: this.retailBack.toFixed(2) },
        { rowIndex: 15, item: '销售退货', amount: this.saleBack.toFixed(2) },
        { rowIndex: 16, item: '采购订单', amount: this.purchaseOrder.toFixed(2) },
        { rowIndex: 17, item: '采购入库', amount: this.purchaseIn.toFixed(2) },
        { rowIndex: 18, item: '盘亏', amount: this.stockCheckLoss.toFixed(2) },
        { rowIndex: 19, item: '支出单', amount: this.itemOut.toFixed(2) },
        { rowIndex: 20, item: '付款单', amount: this.moneyOut.toFixed(2) },
        { rowIndex: '合计', item: '利润', amount: '￥' + this.profit.toFixed(2) }
      ]
      this.printQueryParam = {
        beginTime: this.queryParam.beginTime,
        endTime: this.queryParam.endTime,
        profit: this.profit,
        incomeTotal: this.incomeTotal,
        paymentTotal: this.paymentTotal
      }
      this.printMode = true
    },
    onDesignerChange(visible) {
      this.printTitle = visible ? '利润报表-报表设计' : '利润报表-打印预览'
    },
  mounted() {
    this.loadData()
  }
}
}
</script>

<style scoped>
.detail-head {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.detail-head-group {
  padding: 8px 16px;
  font-size: 16px;
  font-weight: bold;
}
.detail-item ul {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #e8e8e8;
}
.detail-item li {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
}
.detail-item li:last-child {
  border-bottom: none;
}
.group-head-left, .group-head-right {
  padding: 8px 16px;
  font-weight: bold;
  background: #fafafa;
}
.group-head-left {
  flex: 1;
  border-right: 1px solid #e8e8e8;
}
.group-head-right {
  width: 200px;
  text-align: right;
}
.group-item-left {
  flex: 1;
  padding: 6px 16px;
  border-right: 1px solid #e8e8e8;
}
.group-item-right {
  width: 200px;
  padding: 6px 16px;
  text-align: right;
}
.item-padd .group-item-left {
  padding-left: 32px;
}
.text-red {
  color: #f5222d;
}
.form-tip {
  margin-top: 16px;
  color: #999;
  font-size: 12px;
}
</style>